export const BREAKPOINTS = {
  DESKTOP: 1024, // Screens wider than 1024px
  TABLET: 1023, // Tablets and larger smartphones (768px to 1024px)
  VM: 960, // 10inch = 960px minim size to open VMs
  MOBILE: 768, // Medium-sized smartphones (360px to 768px)
  SMALL_MOBILE: 360, // Small smartphones (Less than 360px)
};
